import { useState, useEffect } from 'react';
import { TrendPeriod } from '@/components/dashboard/TrendPeriodToggle';

const STORAGE_KEY = 'dashboard-trend-period';

export function usePersistedTrendPeriod(defaultPeriod: TrendPeriod = 'week') {
  const [trendPeriod, setTrendPeriod] = useState<TrendPeriod>(() => {
    if (typeof window === 'undefined') return defaultPeriod;
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && ['week', 'month', 'year'].includes(stored)) {
      return stored as TrendPeriod;
    }
    return defaultPeriod;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, trendPeriod);
  }, [trendPeriod]);

  return [trendPeriod, setTrendPeriod] as const;
}
